<!--做题新页面-->
<template>
  <div class="content">
    <div class="question" v-if="GetquestionDesc">
      <div class="text">{{ GetquestionDesc }}</div>
    </div>
    <div class="question_choose">
      <div class="choose_danger">
        *以下选项老师根据学生实际情况选择，选项可多选和不选
      </div>
      <div class="questionLists">
        <div
          class="questionList"
          v-for="(item, index) in questions"
          :key="index"
        >
          <span>{{ index + 1 }}.{{ item.Ex_Questions }}</span>
          <div 
            v-for="(cc, nn) in item.Ex_AnswerList"
            :key="nn"
            style="font-size: 16px; color: #666"
          >
            {{ cc.Option }}
          </div>

          <div class="rate" v-if="!dateInfo.IsBaby">
            <!-- ★修改：评分控件保持不变，初始 value=null 表示未选择 -->
            <el-rate
              v-model="item.value"
              :max="6"
              @change="onRateChange($event, index, item)"
            ></el-rate>
          </div>

          <div class="" v-else>
            <!-- ★修改：单选题初始 value=null，不选任何一个 -->
            <el-radio-group v-model="item.value">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>

    <el-button type="primary" size="mini" @click="AdminSaveBatchTermInfo">提交评价</el-button>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="25%"
    >
      <div>
        <div class="mask_title">提交成功!</div>
        <div class="lable_desc">
          评价报告请在评价数据管理班级管理个人页面查看
        </div>
      </div>
      <div @click="onSubmit" class="submit_btn">好的</div>
    </el-dialog>
  </div>
</template>

<script>
import {
  FrontGetQuestionByCategory,
  AdminSaveBatchTermInfo,
} from "../../api/api";

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      questionDesc: "", //问题描述
      questions: [],
      iskai: false,
      dateInfo: {},
    };
  },
  computed: {
    GetquestionDesc() {
      if (this.questionDesc) {
        return this.questionDesc.replace(/&nbsp;/gi, "").replace(/<[^>]+>/gi, "");
      } else {
        return "";
      }
    },
  },
  methods: {
    onRateChange(e, index) {
      this.questions[index].value = e;
    },
    onSubmit() {
      this.dialogVisible = false;
      this.$router.back();
    },

    // ★新增：提交前校验未选择项
    validateUnanswered() {
      const missing = [];
      this.questions.forEach((q, i) => {
        // 未选择：null 或 undefined 视为未选；注意 0 是有效评分（若你将来允许 0 分），这里我们按“必须选择”处理，所以只认 null/undefined 为未选
        if (q.value === null || q.value === undefined) {
          missing.push(i + 1); // 题号从 1 开始
        }
      });
      return missing;
    },

    //提交
    async AdminSaveBatchTermInfo() {
      // ★修改：增加必选校验
      const missing = this.validateUnanswered();
      if (missing.length > 0) {
        const msg = `还有题目未选择：第 ${missing.join("、")} 题`;
        // 用 MessageBox 弹窗更明显；如果你没全局注册也可用 this.$message.error
        this.$alert(msg, "提示", { type: "warning" });
        return;
      }

      let contentArr = [];
      this.questions.forEach((item) => {
        contentArr.push({
          id: item.Id,
          value: item.value,
        });
      });

      if (this.iskai) return;
      this.iskai = true;
      try {
        let xhr = await AdminSaveBatchTermInfo({
          gradeId: this.dateInfo.gradeId,
          classId: this.dateInfo.classId,
          cateId: this.dateInfo.cateId,
          studentId: this.dateInfo.studentId,
          cycleId: this.dateInfo.cycleId,
          content: contentArr,
          studentIds: this.dateInfo.studentIds,
        });
        if (xhr.data.success) {
          this.dialogVisible = true;
        } else {
          this.$message.error(xhr.data.msg);
        }
      } finally {
        this.iskai = false;
      }
    },

    // 获取题目
    async FrontGetQuestionByCategory() {
      let xhr = await FrontGetQuestionByCategory({
        SId: this.dateInfo.SId,
        IsBaby: this.dateInfo.IsBaby,
        BabyLevel: this.dateInfo.BabyLevel,
      });
      if (xhr.data.success) {
        // ★修改：默认都不选 -> 设为 null（之前是 1/0）
        xhr.data.response.forEach((item) => {
          item.value = null;
        });
        this.questions = xhr.data.response;
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },
  },
  created() {
    this.dateInfo = JSON.parse(unescape(this.$route.query.dateInfo));
    this.questionDesc = this.dateInfo.detail;
  },
  mounted() {
    this.FrontGetQuestionByCategory();
  },
};
</script>

<style scoped lang="less">
.el-rate {
  height: 50px;
  padding: 10px 0 10px 0;
}
/deep/ .el-rate__icon {
  font-size: 35px;
}
.content {
  padding: 0 20px;
  background: #ffffff;
  padding-top: 10px;
  padding-bottom: 100px;
  .question {
    background: #f2f5ff;
    border-radius: 30px;
    .text {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      padding: 26px 7px 36px 15px;
    }
  }
  .question_choose {
    padding: 21px 0 49px 37px;
    margin-top: 12px;
    .choose_danger {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #f44f4f;
      line-height: 36px;
    }
    .questionLists {
      span {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        margin-bottom: 10px;
      }
      .checkBoxIndex {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .cricleBox {
        width: 13px;
        height: 13px;
        border: 2px solid #999999;
        border-radius: 50%;
      }
      .cricleBoxActive {
        background: #4cbff4;
        border: 2px solid #4cbff4;
      }
      .Question {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        padding-left: 15px;
      }
      .RadioBox {
        cursor: pointer;
      }
      .RadioBox_flex {
        display: flex;
        align-items: center;
      }
      .question_text {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        padding-left: 32px;
      }
    }
    .sumbit {
      width: 360px;
      height: 40px;
      background: #4cbff4;
      border-radius: 5px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin: 0 auto;
      margin-top: 80px;
      cursor: pointer;
    }
  }
  /deep/.el-dialog {
    border-radius: 30px;
    padding: 0 60px;
    .mask_title {
      font-size: 24px;
      font-family: PingFang SC;
      color: #333333;
      text-align: center;
    }
    .lable_desc {
      margin-top: 30px;
      text-align: center;
    }
    .submit_btn {
      width: 115px;
      height: 40px;
      background: #4cbff4;
      border-radius: 5px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin: 0 auto;
      margin-top: 60px;
      cursor: pointer;
    }
  }
}
</style>
